import { mapGetters, mapMutations } from 'vuex';

export default {
  computed: {
    ...mapGetters('DIALOG', ['GET_DIALOG_STACK_SIZE']),
    dialog: {
      get() {
        switch (this.modalName) {
          case 'search_executives':
            return this.$store.state.DIALOG.search_executives;
          case 'search_executives_multi':
            return this.$store.state.DIALOG.search_executives_multi;
          case 'change_approval_line':
            return this.$store.state.DIALOG.change_approval_line;
          case 'add_referrer':
            return this.$store.state.DIALOG.add_referrer;
          case 'select_work_term':
            return this.$store.state.DIALOG.select_work_term;
          case 'calendar_detail':
            return this.$store.state.DIALOG.calendar_detail;
          case 'application_viewer':
            return this.$store.state.DIALOG.application_viewer;
          case 'member_profile':
            return this.$store.state.DIALOG.member_profile;
          case 'board_detail':
            return this.$store.state.DIALOG.board_detail;
          case 'pay_detail':
            return this.$store.state.DIALOG.pay_detail;
          case 'pay_calc_detail':
            return this.$store.state.DIALOG.pay_calc_detail;
          case 'application_confirm':
            return this.$store.state.DIALOG.application_confirm;
          case 'reject_reason':
            return this.$store.state.DIALOG.reject_reason;
          case 'select_annual_plan_date':
            return this.$store.state.DIALOG.select_annual_plan_date;
          case 'find_password':
            return this.$store.state.DIALOG.find_password;
          case 'reset_password_single':
            return this.$store.state.DIALOG.reset_password_single;
          case 'reset_password_multi':
            return this.$store.state.DIALOG.reset_password_multi;
          case 'add_mgrrer': //담당자추가
            return this.$store.state.DIALOG.add_mgrrer;
          case 'add_work_log': //업무일지추가
            return this.$store.state.DIALOG.add_work_log;
          case 'work_log_detail': // 업무일지상세
            return this.$store.state.DIALOG.work_log_detail;
          case 'view_auth_org_list': // 조회권한 부서목록
            return this.$store.state.DIALOG.view_auth_org_list;
          case 'work_log_not_registered_list': // 업무일지 미작성목록
            return this.$store.state.DIALOG.work_log_not_registered_list;
          case 'work_log_not_viewed_list': // 업무일지 미열람목록
            return this.$store.state.DIALOG.work_log_not_viewed_list;
          case 'certificate_rd': // 제증명서 RD
            return this.$store.state.DIALOG.certificate_rd;
        }
      },
      set() {
        this.closeModal();
      },
    },

    // 기본 모달 타입
    scrollViewStyle() {
      return `max-height: ${window.innerHeight - this.vt_header_title}px`;
    },

    /* 모달 타입별 스크롤 컨텐츠 제외 영역 높이 */
    // 헤더
    vt_header() {
      return this.$store.state.header;
    },
    // 헤더 + 제목
    vt_header_title() {
      return this.$store.state.header + this.$store.state.title;
    },
    // 헤더 + 제목 + 버튼
    vt_header_title_button() {
      return (
        this.$store.state.header +
        this.$store.state.title +
        this.$store.state.bottomBtn
      );
    },
    // 헤더 + 제목 + 더보기
    vt_header_title_more() {
      return (
        this.$store.state.header +
        this.$store.state.title +
        this.$store.state.moreBtn
      );
    },
  },
  watch: {
    dialog(data) {
      // 이벤트 중복 방지를 위해 기존 리스너 제거
      this.removePopstateListener();

      // 첫번째 모달에만 이벤트 리스너 추가
      if (data && this.GET_DIALOG_STACK_SIZE === 1) {
        window.history.pushState(null, '', location.href);
        this.addPopstateListener();
      }
    },
  },
  methods: {
    ...mapMutations('SPINNER', [
      'ON_APP_SPINNER',
      'OFF_APP_SPINNER',
      'ON_COMMON_SPINNER',
      'OFF_COMMON_SPINNER',
    ]),

    /* 뒤로가기시 열려 있는 모달 토글 */
    handlePopstate() {
      this.toggleModal();
    },
    /* 모달 닫기 버튼 클릭시 */
    closeModal() {
      this.toggleModal();
      // 모든 모달이 닫혔을때만 뒤로가기
      if (this.GET_DIALOG_STACK_SIZE === 0) {
        history.go(-1);
      }
    },
    /* 모달 닫기 버튼 클릭시 (callback ver) */
    callbackCloseModal() {
      this.$store.commit('DIALOG/SET_DIALOG_CALLBACK', true); // 모달 종료 콜백 ON
      this.closeModal();
    },
    /* 모달 닫기 */
    toggleModal() {
      if (this.dialog) {
        this.$store.commit('DIALOG/TOGGLE_MODAL', this.modalName);
        this.OFF_APP_SPINNER();
      }
    },
    offModal(modalName) {
      this.$store.state.DIALOG[modalName] = false;
    },
    /* 뒤로가기 이벤트 리스너 추가 */
    addPopstateListener() {
      window.addEventListener('popstate', this.handlePopstate);
    },
    /* 뒤로가기 이벤트 리스너 제거 */
    removePopstateListener() {
      window.removeEventListener('popstate', this.handlePopstate);
    },
  },
  destroyed() {
    // 열려있는 모달과 이벤트 제거, 스피너 닫기
    this.removePopstateListener();
    this.toggleModal();
  },
};
